module.exports = "/images/companies_loader_frame.png?aeb7ffabfa1e27b35689ed48cba294e7";